// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Tilia from "tilia/src/Tilia.bs.jsx";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";

let tree = Tilia.tilia({
  toasts: []
});

function addMessage(toast) {
  tree.toasts = Belt_Array.concatMany([
    tree.toasts,
    [toast]
  ]);
}

function removeMessage(id) {
  tree.toasts = tree.toasts.filter(message => message.id !== id);
}

export {
  tree,
  addMessage,
  removeMessage,
}
/* tree Not a pure module */
